/**
 * MDB Rating — לא נכלל ב-initMDB הדיפולטיבי של mdb.min.js; חובה אתחול ידני.
 * https://mdbootstrap.com/docs/standard/components/rating/#docsTabsAPI
 *
 * דורש mdb.min.js מלא (כולל ייצוא Rating) תחת assets/md/js/.
 * נטען סינכרונית אחרי mdb.min.js; נוספת ריצה ב-DOMContentLoaded למקרי סדר טעינה.
 */
(function () {
  "use strict";

  function getMdbRatingClass() {
    var m = window.mdb;
    if (!m) {
      return null;
    }
    if (typeof m.Rating === "function") {
      return m.Rating;
    }
    var d = m.default;
    if (d && typeof d.Rating === "function") {
      return d.Rating;
    }
    return null;
  }

  function initRatings() {
    var RatingClass = getMdbRatingClass();
    if (!RatingClass) {
      return;
    }

    var list = document.querySelectorAll("ul.rating[data-mdb-rating-init]");
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      try {
        if (typeof RatingClass.getOrCreateInstance === "function") {
          RatingClass.getOrCreateInstance(el);
          continue;
        }
        var existing =
          typeof RatingClass.getInstance === "function" ? RatingClass.getInstance(el) : null;
        if (existing) {
          continue;
        }
        new RatingClass(el);
      } catch (err) {
        console.error("[business-sites] Rating", err);
      }
    }
  }

  function getMdbLightboxClass() {
    var m = window.mdb;
    if (!m) {
      return null;
    }
    if (typeof m.Lightbox === "function") {
      return m.Lightbox;
    }
    var d = m.default;
    if (d && typeof d.Lightbox === "function") {
      return d.Lightbox;
    }
    return null;
  }

  function initHeroLightbox() {
    var LightboxClass = getMdbLightboxClass();
    if (!LightboxClass) {
      return;
    }

    var nodes = document.querySelectorAll(".business-hero--gallery [data-mdb-lightbox-init]");
    for (var i = 0; i < nodes.length; i++) {
      try {
        if (typeof LightboxClass.getOrCreateInstance === "function") {
          LightboxClass.getOrCreateInstance(nodes[i]);
          continue;
        }
        var existing =
          typeof LightboxClass.getInstance === "function" ? LightboxClass.getInstance(nodes[i]) : null;
        if (existing) {
          continue;
        }
        new LightboxClass(nodes[i]);
      } catch (err) {
        console.error("[business-sites] Lightbox", err);
      }
    }
  }

  function bindHeroThumbs() {
    var galleries = document.querySelectorAll(".business-hero--gallery");
    for (var i = 0; i < galleries.length; i++) {
      (function (gallery) {
        if (gallery.getAttribute("data-hero-thumbs-bound") === "1") {
          return;
        }
        var mainImg = gallery.querySelector(".business-hero__main-img");
        var buttons = gallery.querySelectorAll(".business-hero__thumb-btn");
        if (!mainImg || !buttons.length) {
          return;
        }
        gallery.setAttribute("data-hero-thumbs-bound", "1");

        for (var t = 0; t < buttons.length; t++) {
          buttons[t].addEventListener("click", function () {
            var full = this.getAttribute("data-full") || "";
            if (full) {
              mainImg.setAttribute("src", full);
              mainImg.setAttribute("data-mdb-img", full);
            }
            for (var k = 0; k < buttons.length; k++) {
              buttons[k].classList.remove("active");
            }
            this.classList.add("active");
          });
        }
      })(galleries[i]);
    }
  }

  function initHeroGallery() {
    bindHeroThumbs();
    initHeroLightbox();
  }

  function boot() {
    initRatings();
    initHeroGallery();
    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        function () {
          initRatings();
          initHeroGallery();
        },
        { once: true }
      );
    }
  }

  boot();

  window.businessSitesInitMdbComponents = function () {
    initRatings();
    initHeroGallery();
  };
})();
